/**
 * Pure helpers for mapping Template Library category → rules-engine template kind.
 * Lives outside React hooks so Medplum bot bundling does not pull UI/runtime deps.
 */
import type { TemplateCategory } from '../../template-library/types';

const FORM_CATEGORIES: TemplateCategory[] = ['forms', 'measures'];

export function isEmailTemplate(category: string | undefined): boolean {
  return category === 'client-operations';
}

export function isAssignableFormTemplate(category: string | undefined): boolean {
  return FORM_CATEGORIES.includes(category as TemplateCategory);
}

export function inferTemplateType(category: string | undefined): 'email' | 'form' | 'document' | string {
  if (isEmailTemplate(category)) return 'email';
  if (isAssignableFormTemplate(category)) return 'form';
  return 'document';
}
